<template>
  <div class="pratos-container" :class="{'visible':visible}">
    <div class="pt-header">
      <span v-text="$t('plate')"></span>
      <span v-text="$t('minimum_month')"></span>
      <span v-text="$t('maximum_month')"></span>
      <span v-text="$t('maximum_week')"></span>
      <span v-text="$t('cost_unit')"></span>
      <span v-text="$t('per_capita_average')"></span>
      <span v-text="$t('incidence')"></span>
    </div>
    <div class="pt-body">
      <div class="pratos" v-for="pratos in pratoList" :class="{lackOfCost: lackOfCost(pratos)}" :title="showError(pratos)">
        <span v-text="pratos.nm_prato" :title="getPlateTitle(pratos)"></span>
        <span v-text="pratos.freq.qt_min_mes || '--'"></span>
        <span v-text="pratos.freq.qt_max_mes || '--'"></span>
        <span v-text="pratos.freq.qt_max_sem || '--'"></span>
        <span v-text="'R$ ' + parseFloat(pratos.vlr_prato).toFixed(5).replace('.', ',').replace(/([0-9]{3}),([0-9]{5}$)/g, '.$1,$2')"></span>
        <span v-text="'R$ ' + parseFloat(pratos.vlr_pu).toFixed(5).replace('.', ',').replace(/([0-9]{3}),([0-9]{5}$)/g, '.$1,$2')"></span>
        <span v-text="pratos.qt_utilizado"></span>
      </div>
    </div>
  </div>
</template>

<script>

import { t } from 'i18next'

export default {
  name: "AnalResultPrato",
  props: ["pratoList", "visible"],
  data() {
    return {};
  },
  methods: {
    showError: function(data){
      if(this.lackOfCost(data)){
        return t('dish_without_cost_or_with_outdated_cost');
      }
      return null;
    },
    lackOfCost: function(data){
      return data.id_prato_sem_custo;
    },
    getPlateTitle: function(prato){
      let desc = `${prato.nm_prato} \n`;
      desc += `${prato.nm_tipocorte ? t('TP_CUT') + prato.nm_tipocorte + "\n" : ""}`;
      desc += `${prato.nm_modopreparo ? t('PREPARATION_MODE') + prato.nm_modopreparo + "\n" : "" }`;
      desc += `${prato.nm_ingrediente_1? t('ing_main_1') + ": " + prato.nm_ingrediente_1 + "\n": ""}`;
      desc += `${prato.nm_ingrediente_2 ? t('ing_main_2') + ": " + prato.nm_ingrediente_2 + "\n": ""}`;
      return desc;
    }
  },
  watch: {
    visible: function() {
      this.visible;
    }
  }
};
</script>

<style scoped lang="less">
@import (reference) url("../../assets/variables.less");
.pratos-container {
  font-size: 13px;
  .sombra;
  border-radius: 12px;
  border: 1px solid rgba(33, 33, 70, 0.12);
  overflow: hidden;
  background: #fff;
}
.pt-header {
  background: linear-gradient(160deg, #24244f 0%, #1e2c6c 100%);
  color: #fff;
  display: grid;
  grid-template-columns: 21% 13% 13% 13% 13% 13% 13%;
  position: sticky;
  top: 0;
  z-index: 1;
  box-shadow: 0 2px 8px rgba(19, 24, 41, 0.2);
  span {
    font-size: 0.72rem;
    font-weight: 600;
    letter-spacing: 0.01em;
  }
  span:first-of-type {
    padding-left: 8px;
    margin: auto 0;
  }
  span:not(:first-of-type) {
    text-align: center;
    padding-left: 2px;
    display: table;
    margin: auto;
  }
}
.pt-body {
  max-height: calc(100vh - 220px);
  overflow: auto;
  background: #fff;

  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(70, 83, 124, 0.45);
    border-radius: 999px;
  }

  .pratos {
    &:nth-of-type(2n) {
      background: rgba(242, 245, 252, 0.9);
    }
    display: grid;
    grid-template-columns: 21% 13% 13% 13% 13% 13% 13%;
    border-bottom: 1px solid rgba(33, 33, 70, 0.08);
    transition: background-color 0.14s ease;

    &:hover {
      background: rgba(220, 232, 252, 0.55);
    }

    span {
      padding: 7px 0;
    }
    span:first-of-type {
      padding-left: 8px;
      font-size: 13px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: #1f2747;
      font-weight: 600;
    }
    span:not(:first-of-type) {
      text-align: center;
      color: #212146;
    }
  }
  .lackOfCost{
    color: #c62828;
  }
}
</style>
